import { Controller } from 'stimulus'
import { getAppliedParams } from '../packs/filter_helpers';

export default class extends Controller {
  static targets = ["seriesContainer", "primaryMetric", "secondaryMetric", "existingSeries"]
  static values = { seriesCounter: Number, existingSeries: String, axisParams: String }

  connect() {
    this.seriesCounterValue = 0
  }

  modalShown(event) {
    // Check if we have existing series data to populate

    if ($(event.target).data('existing-series-value')) {
      this.existingSeriesValue = $(event.target).data('existing-series-value')
      this.axisParamsValue = $(event.target).data('axis-params-value')
      this.populateExistingSeries()
    } else if (this.seriesContainerTarget.children.length === 0) {
      this.addSeries()
    }
  }

  populateExistingSeries() {
    try {
      const existingData = eval(this.existingSeriesValue)
      const axisParams = eval(this.axisParamsValue)

      // Clear existing series
      this.seriesContainerTarget.innerHTML = ''
      this.seriesCounterValue = 0
      
      // Determine metrics from existing data
      const primaryMetric = axisParams.primary
      const secondaryMetric = axisParams.secondary
      
      // Set metric selects
      if (primaryMetric) this.primaryMetricTarget.value = primaryMetric
      if (secondaryMetric) this.secondaryMetricTarget.value = secondaryMetric
      
      // Create series for each existing data entry
      existingData.forEach((seriesData, index) => {
        this.addSeriesWithData(seriesData)
      })
      
    } catch (error) {
      console.error('Error parsing existing series data:', error)
      // Fallback to empty series
      if (this.seriesContainerTarget.children.length === 0) {
        this.addSeries()
      }
    }
  }

  addSeriesWithData(seriesData = null) {
    this.seriesCounterValue++
    const seriesHtml = `
      <div class="card mb-3 series-row" data-series="${this.seriesCounterValue}">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="card-title mb-0">Series ${this.seriesCounterValue}</h6>
            <button type="button" class="btn btn-sm btn-outline-danger" 
                    data-action="click->chart-builder#removeSeries" 
                    ${this.seriesCounterValue === 1 ? 'style="display:none"' : ''}>
              <i class="fas fa-trash"></i>
            </button>
          </div>
          
          <div class="row">
            <!-- Breakdown Type Column -->
            <div class="col-md-4 series-step" data-step="1">
              <label class="form-label">Breakdown Type</label>
              <div class="breakdown-type-container">
                <div class="text-center">Loading...</div>
              </div>
            </div>
            
            <!-- Breakdown Value Column -->
            <div class="col-md-4 series-step" data-step="2" ${!seriesData ? 'style="display: none;"' : ''}>
              <label class="form-label">Value</label>
              <div class="breakdown-value-container">
                <!-- Breakdown value partial will be loaded here -->
              </div>
            </div>
            
            <!-- Axis Assignment Column -->
            <div class="col-md-4 series-step" data-step="3" ${!seriesData ? 'style="display: none;"' : ''}>
              <label class="form-label">Axis Assignment</label>
              <select class="form-control axis-assignment">
                <option value="">Select axis...</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    `
    
    this.seriesContainerTarget.insertAdjacentHTML('beforeend', seriesHtml)
    const newSeriesRow = this.seriesContainerTarget.lastElementChild

    if (seriesData) {
      this.populateSeriesData(newSeriesRow, seriesData)
    } else {
      this.loadBreakdownType(newSeriesRow)
    }
  }

  addSeries() {
    this.addSeriesWithData(null)
  }

  populateSeriesData(seriesRow, seriesData) {
    // Extract breakdown type from breakdown_attribute object
    const breakdownAttribute = seriesData.breakdown_attribute
    let breakdownType = null
    let breakdownValues = []
    
    // Determine breakdown type and values from the data structure
    if (breakdownAttribute.channel) {
      breakdownType = "Platform"
      breakdownValues = seriesData.channel || []
    } else if (breakdownAttribute.post) {
      breakdownType = breakdownAttribute.post
      // Get the breakdown values from the corresponding key in seriesData
      const valueKey = Object.keys(seriesData).find(key => 
        key !== 'breakdown_attribute' && key !== 'search_by' && Array.isArray(seriesData[key])
      )
      breakdownValues = valueKey ? seriesData[valueKey] : []
    } else if (breakdownAttribute.actor_set) {
      breakdownType = "actor_set"
      breakdownValues = seriesData.actor_set || []
    }
    
    if (breakdownType) {
      // Store breakdown type on the series row
      seriesRow.dataset.breakdownType = breakdownType

      this.loadBreakdownType(seriesRow, seriesData)
      this.showStep(seriesRow, 2)
      this.loadBreakdownValues(seriesRow, breakdownType, seriesData)
      this.showStep(seriesRow, 3)

      const axisSelect = seriesRow.querySelector('.axis-assignment')
      
      // Update axis options first
      this.updateAxisOptions(seriesRow)
      const isSecondary = seriesData.search_by !== this.primaryMetricTarget.value
      axisSelect.value = isSecondary ? 'secondary' : 'primary'
    }
  }

  preselectBreakdownValues(seriesRow, breakdownValues) {
    const checkboxes = seriesRow.querySelectorAll('.breakdown-value-container input[type="checkbox"]')
    checkboxes.forEach(checkbox => {
      const value = checkbox.value || checkbox.id.split('-').pop()
      if (breakdownValues.includes(value)) {
        checkbox.checked = true
      }
    })
  }

  removeSeries(event) {
    event.target.closest('.series-row').remove()
    this.updateSeriesNumbers()
  }

  updateSeriesNumbers() {
    const seriesRows = this.seriesContainerTarget.querySelectorAll('.series-row')
    seriesRows.forEach((row, index) => {
      row.querySelector('.card-title').textContent = `Series ${index + 1}`
      row.setAttribute('data-series', index + 1)
    })
    this.seriesCounterValue = seriesRows.length
  }

  metricsChanged() {
    this.updateAxisOptions()
  }

  loadBreakdownType(seriesRow, seriesData = null) {
    const container = seriesRow.querySelector('.breakdown-type-container')

    Rails.ajax({
      url: '/monitoring/breakdown_filter_partial',
      type: 'GET',
      data: $.param(seriesData),
      dataType: 'json',
      success: (response) => {
        container.innerHTML = response.template
        
        // Add event listener to the breakdown filter dropdown
        const dropdown = container.querySelector('#breakdown-dropdown-btn')
        const dropdownItems = container.querySelectorAll('.dropdown-item')
        
        if (dropdown && dropdownItems.length > 0) {
          dropdownItems.forEach(item => {
            item.addEventListener('click', (e) => {
              e.preventDefault()
              
              // Extract breakdown type and value from the link href
              const href = e.target.getAttribute('href')
              const urlParams = new URLSearchParams(href.split('?')[1])

              let breakdownModel = null
              let breakdownType = null
              let buttonText = e.target.textContent.trim()

              if (urlParams.has('breakdown_attribute[channel]')) {
                breakdownModel = 'channel'
                breakdownType = urlParams.get('breakdown_attribute[channel]')
                buttonText = `Channel: ${buttonText}`
              } else if (urlParams.has('breakdown_attribute[post]')) {
                breakdownModel = 'post'
                breakdownType = urlParams.get('breakdown_attribute[post]')
                buttonText = `Post: ${buttonText}`
              } else if (urlParams.has('breakdown_attribute[actor_set]')) {
                breakdownModel = 'actor_set'
                breakdownType = urlParams.get('breakdown_attribute[actor_set]')

                // Find the actor set name from the preceding dropdown header
                let actorSetName = 'Actor Set'
                let currentElement = e.target.previousElementSibling

                // Walk backwards through siblings to find the dropdown-header
                while (currentElement) {
                  if (currentElement.classList && currentElement.classList.contains('dropdown-header')) {
                    actorSetName = currentElement.textContent.trim()
                    break
                  }
                  currentElement = currentElement.previousElementSibling
                }

                buttonText = `${actorSetName}: ${buttonText}`
              }
              
              // Update button text with category prefix
              dropdown.textContent = buttonText
              
              // Store breakdown type in the series row for later retrieval
              seriesRow.dataset.breakdownType = breakdownType
              
              // Show step 2 and load breakdown values
              if (breakdownType) {
                this.showStep(seriesRow, 2)
                this.loadBreakdownValues(seriesRow, breakdownType)
              }
            })
          })
        }
      }
    })
  }

  showStep(seriesRow, stepNumber) {
    const step = seriesRow.querySelector(`[data-step="${stepNumber}"]`)
    if (step) {
      step.style.display = 'block'
    }
  }

  loadBreakdownValues(seriesRow, breakdownType, seriesData = null) {
    const container = seriesRow.querySelector('.breakdown-value-container')
    container.innerHTML = '<div class="text-center">Loading values...</div>'

    Rails.ajax({
      url: `/monitoring/breakdown_values_partial?breakdown_type=${breakdownType}`,
      type: 'GET',
      data: $.param(seriesData),
      dataType: 'json',
      success: (response) => {
        if (response.error) {
          console.error('Error fetching breakdown values:', response.error)
          container.innerHTML = '<div class="text-danger">Error loading values</div>'
        } else {
          container.innerHTML = response.template
          $(container).data('param-name', response.param_name);

          if (seriesData) {
            $(container).data("breakdown_values", seriesData.breakdown_values)
          }
        }
      }
    })
  }

  reRenderFilterPartial(event) {
    event.preventDefault()
    
    const filterContainer = $(event.target).closest('.filter-container, .breakdown-value-container')
    const seriesRow = filterContainer.closest('.series-row')[0]

    // Determine the breakdown type for this filter
    const breakdownType = seriesRow.dataset.breakdownType
    
    if (!breakdownType) {
      console.error('No breakdown type found for filter')
      return
    }
    
    // Determine param name based on breakdown type
    let paramName = filterContainer.data("param-name")
    
    // Get applied parameters from the filter
    const appliedParams = getAppliedParams(event, filterContainer, paramName)
    const has_params = Object.keys(appliedParams).length > 0
    
    // Add breakdown type to params for server
    appliedParams['breakdown_type'] = breakdownType
    
    // Re-render this specific filter partial
    Rails.ajax({
      type: 'GET',
      url: '/monitoring/breakdown_values_partial',
      data: $.param(appliedParams),
      dataType: 'json',
      success: (response) => {
        filterContainer.html(response.template)
        
        // Close the dropdown
        const dropdown = filterContainer[0].querySelector('.dropdown-menu')
        if (dropdown) {
          dropdown.classList.remove('show')
        }

        filterContainer.data("breakdown_values", appliedParams[`${paramName}`])

        if (has_params) {
          this.showStep(seriesRow, 3)
          this.updateAxisOptions(seriesRow)
        }
      }
    })
  }

  updateAxisOptions(row = null) {
    const primaryMetric = this.primaryMetricTarget.value
    const secondaryMetric = this.secondaryMetricTarget.value
    
    const axisSelects = row ? row.querySelectorAll('.axis-assignment') : this.element.querySelectorAll('.axis-assignment')
    
    axisSelects.forEach(select => {
      select.innerHTML = '<option value="">Select axis...</option>'
      
      if (primaryMetric) {
        const primaryText = this.primaryMetricTarget.options[this.primaryMetricTarget.selectedIndex].text
        select.insertAdjacentHTML('beforeend', `<option value="primary">${primaryText} (Left)</option>`)
      }
      if (secondaryMetric) {
        const secondaryText = this.secondaryMetricTarget.options[this.secondaryMetricTarget.selectedIndex].text
        select.insertAdjacentHTML('beforeend', `<option value="secondary">${secondaryText} (Right)</option>`)
      }
    })
  }

  generateChart() {
    const customChartSeries = []
    
    const seriesRows = this.seriesContainerTarget.querySelectorAll('.series-row')

    seriesRows.forEach(row => {
      const breakdownType = row.dataset.breakdownType
      const axisSelect = row.querySelector('.axis-assignment')
      const breakdownValueContainer = $(row.querySelector('.breakdown-value-container'))

      if (!breakdownType || !axisSelect || !axisSelect.value) {
        console.warn('Incomplete series data, skipping row')
        return
      }
      
      const paramName = breakdownValueContainer.data('param-name')
      if (!paramName) {
        console.warn('No param name found for breakdown type:', breakdownType)
        return
      }
      
      const appliedParams = getAppliedParams(null, breakdownValueContainer, paramName)
      let breakdownValues = []

      breakdownValues = breakdownValueContainer.data("breakdown_values")
      
      // Determine search_by based on axis assignment
      const searchBy = axisSelect.value === 'primary' ? this.primaryMetricTarget.value : this.secondaryMetricTarget.value
      
      // Create breakdown_attribute structure
      let breakdownAttribute = {}
      if (breakdownType === 'Platform') {
        breakdownAttribute = { channel: "Platform" }
      } else if (['post_type', 'is_ad', 'referring_post_type', 'video_type'].includes(breakdownType)) {
        breakdownAttribute = { post: breakdownType }
      } else if (breakdownType === 'actor_set') {
        breakdownAttribute = { actor_set: breakdownValues[0] } // For actor sets, the value is the attribute key ID
        // breakdownValues = [] // Actor sets don't have separate breakdown values
      } else {
        breakdownAttribute = { post: breakdownType }
      }
      
      const seriesData = {
        breakdown_attribute: breakdownAttribute,
        breakdown_values: breakdownValues,
        search_by: searchBy,
        param_name: paramName
      }
      
      customChartSeries.push(seriesData)
    })

    var axis_params = {primary: this.primaryMetricTarget.value, secondary: this.secondaryMetricTarget.value}
    
    if (customChartSeries.length === 0) {
      alert('Please complete at least one series before generating the chart.')
      return
    }
    
    // Create URL parameters
    const params = new URLSearchParams(window.location.search)
    params.set('custom_chart_series', JSON.stringify(customChartSeries))
    params.set('axis_params', JSON.stringify(axis_params))

    params.delete('breakdown_attribute')
    
    // Navigate to monitoring index with custom chart parameters
    const newUrl = window.location.origin + '/monitoring?' + params.toString()
    window.location.href = newUrl
    
    // Close modal
    const modal = bootstrap.Modal.getInstance(this.element.closest('.modal'))
    if (modal) {
      modal.hide()
    }
  }
}
